import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { 
  Layout,
  List,
  Empty,
  Button,
  ConfigProvider,
  Badge,
  Popconfirm,
} from 'antd';

import moment from 'moment';

import { setActive } from 'redux/conversations';
import { isAnswerable } from './utils';


const CustomEmpty = () => (<Empty description="No Pending Chats"/>);

class ConversationList extends React.Component {
  static propTypes = {
    conversations: PropTypes.array,
    onCall: PropTypes.bool,
    activeId: PropTypes.string,
    startCall: PropTypes.func,
  };

  render() {
    return (
      <Layout.Sider style={{ background: '#fff' }} width={350}>
        <ConfigProvider renderEmpty={CustomEmpty}>
        <List
          dataSource={this.props.conversations}
          bordered
          header="Conversations"
          className="conversation-list"
          renderItem={this._renderItem}
        />
        </ConfigProvider>
      </Layout.Sider>
    );
  }

  _renderItem = item => (
    <List.Item key={item.id} className={this._isActive(item) && 'active'}>
      <List.Item.Meta
        title={this._renderTitle(item)}
        description={
          <div>
            <p style={{ margin: '0' }}>{moment(item.created_at).fromNow()}</p>
            <p style={{ margin: '0' }}>On the {item.page || item.url}</p>
          </div>
        }
      />
      {this._renderButton(item)}
    </List.Item>
  )

  _isActive = item => {
    const { activeId } = this.props;
    if (!activeId) return false;

    return activeId === item.id;
  }

  _renderButton = item => {
    const callBackAndAnswer = () => {
      this.props.setActive(item.id)
      if (isAnswerable(item)) {
        this.props.startCall()
      }
    };
    const answerable = isAnswerable(item);
    const button = (
      <Button
        type={answerable ? "primary" : "default"}
        size="small"
        onClick={!this.props.onCall ? callBackAndAnswer : () => {}}
      >
        {answerable ? "Answer" : "Review"}
      </Button>

    );

    if (this.props.onCall) {
      return (
        <Popconfirm
         key="1"
         title="Changing conversation will end call"
         onConfirm={callBackAndAnswer}
         okText="Open"
         cancelText="Cancel"
        >
          {button}
        </Popconfirm>
      );
    }

    return button;
  }

  _renderTitle = item => {
    if (!isAnswerable(item)) return item.name.replace(/\b\w/g, l => l.toUpperCase());

    return (
      <span style={{ textTransform: 'capitalize' }}><Badge status="processing" /> {item.name}</span>
    );
  }
}

export default connect(
  state => ({ 
    conversations: state.conversations.conversations,
    onCall: state.conversations.onCall,
    activeId: state.conversations.activeId,
  }),
  { setActive },
)(ConversationList);
